<div class="login-page">
  <app-login-box></app-login-box>
</div>
